import { motion } from 'framer-motion';

interface FavoriteTimeBoxProps {
  hour: number;
  ampm: string;
  count: number;
}

export const FavoriteTimeBox = ({ hour, ampm, count }: FavoriteTimeBoxProps) => {
  // Format hour to always be 2 digits
  const formatHour = (hour: number) => {
    return hour.toString().padStart(2, '0');
  };

  return (
    <div className="bg-[#8364FF] rounded-xl p-4 border-2 border-[#8364FF] shadow-[4px_4px_0px_0px_#9B86EA] relative">
      {/* Snooze Button */}
      <div className="absolute -top-2 right-4 bg-white px-3 py-0.5 rounded-md border-2 border-[#221A51] text-[#221A51] text-xs font-bold shadow-[2px_2px_0px_0px_#9B86EA]">
        SNOOZE
      </div>
      
      <div className="bg-[#1A1425] p-3 rounded-lg">
        <div className="flex items-baseline justify-center space-x-2">
          {/* Time Display */}
          <div className="font-mono text-[42px] font-black text-[#9BFFA9] tracking-wider tabular-nums">
            {formatHour(hour)}:00
          </div>
          {/* AM/PM Indicator */}
          <div className="text-[#9BFFA9] text-xl font-bold">
            {ampm}
          </div>
        </div>
      </div>

      {/* Stats Display */}
      <div className="mt-3 text-center text-sm">
        <div className="text-white/80">
          <span className="text-white font-bold">{count} purchases</span> around this time
        </div>
      </div>
    </div>
  );
};
